import React from 'react';
import _ from 'lodash';
import Bluebird from 'bluebird';

import {
  ReceiveTier1ReturnAuthorizationMutation,
  ReturnAuthorizationGroupTableDocument,
  ReturnAuthorizationGroupTableQuery,
  useReceiveTier1ReturnAuthorizationMutation
} from 'generated/graphql';

import { gqlCacheUtil } from 'modules/layer00';
import * as types from './types';



export function useReceiveReturnAuthorization() {
  const [fnMutate, tuple] = useReceiveTier1ReturnAuthorizationMutation({
    updateQueries: gqlCacheUtil.genUpdateQueryMap<ReturnAuthorizationGroupTableQuery, ReceiveTier1ReturnAuthorizationMutation>(
      ReturnAuthorizationGroupTableDocument,
      (prevState: ReturnAuthorizationGroupTableQuery, { mutationResult }) => {
        const rma = mutationResult.data?.receiveTier1ReturnAuthorization;
        if (rma?.itemReceipt) {
          return {
            ...prevState,
            tier1ReturnAuthorizations: {
              ...prevState.tier1ReturnAuthorizations,
              nodes: _.filter(prevState.tier1ReturnAuthorizations.nodes, node => node.id !== rma.id)
            }
          };
        }

        return prevState;
      }
    )
  });

  const fnWrappedMutate = React.useCallback(
    async (formState: types.IFormState) => {
      await Bluebird.each(
        formState.lines.filter(line => line.isReceived),
        async line => {
          if (line.item) {
            await fnMutate({
              variables: {
                input: {
                  itemId: line.item.id,
                  returnAuthorizationId: line.returnAuthorizationId,
                  serialNumber: line.serialNumber
                }
              }
            });
          }
        });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
